var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#55ACEE",
    d: "M0 22.5C0 10.074 10.074 0 22.5 0S45 10.074 45 22.5 34.926 45 22.5 45 0 34.926 0 22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.826 18.288l.047.779-.787-.096c-2.864-.365-5.366-1.604-7.491-3.686l-1.039-1.032-.267.762c-.567 1.7-.205 3.496.976 4.703.629.668.487.763-.599.366-.377-.127-.708-.223-.74-.175-.11.111.268 1.557.567 2.129.41.794 1.244 1.573 2.156 2.034l.772.365-.913.016c-.882 0-.913.016-.819.35.315 1.032 1.559 2.129 2.943 2.605l.976.334-.85.509a8.86 8.86 0 0 1-4.217 1.175c-.709.016-1.291.08-1.291.127 0 .16 1.92 1.05 3.037 1.399 3.353 1.032 7.335.588 10.325-1.176 2.124-1.255 4.25-3.75 5.24-6.165.536-1.287 1.07-3.639 1.07-4.767 0-.73.048-.826.93-1.7.519-.508 1.007-1.064 1.101-1.223.157-.302.142-.302-.66-.032-1.339.477-1.528.413-.867-.302.488-.508 1.07-1.43 1.07-1.7 0-.048-.235.032-.503.175-.283.159-.913.397-1.385.54l-.85.27-.771-.524c-.425-.286-1.023-.604-1.338-.7-.802-.222-2.03-.19-2.754.064-1.967.715-3.21 2.558-3.069 4.576z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4e8a44447e08482cf48fca0c85ea2b34.svg";
export { ForwardRef as ReactComponent };